// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__7QFeP","icon":"SortAdornment_icon__B9q1C","up":"SortAdornment_up__2cP4n","down":"SortAdornment_down__2i73u","active":"SortAdornment_active__25y93"};